export default __webpack_public_path__ + "static/media/grocery10.ab5799c9.jpeg";